import { httpPost } from "utils/httpRequest"

export const listProductGates = async () => {
  const resp = await httpPost("admin/productGate/list", {})
  return resp.data
}

export const addProductGate = async ({ code, name, hubspotContentAccessId, checkoutUrl, active }) => {
  const resp = await httpPost("admin/productGate/add", {
    code,
    name,
    hubspotContentAccessId,
    checkoutUrl,
    active,
  })
  return resp.data
}

export const editProductGate = async ({ id, code, name, hubspotContentAccessId, checkoutUrl, active }) => {
  const resp = await httpPost("admin/productGate/edit", {
    id,
    code,
    name,
    hubspotContentAccessId,
    checkoutUrl,
    active,
  })
  return resp.data
}

export const deleteProductGate = async ({ id }) => {
  const resp = await httpPost("admin/productGate/delete", { id })
  return resp.data
}


